export default __webpack_public_path__ + "static/media/044-family.d49999a0.png";